var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-button',{class:_vm.center ? 'done-btn' : '',attrs:{"color":"#1B93AD","disabled":_vm.disabled,"dark":_vm.dark,"fixed":_vm.fixed,"bottom":_vm.bottom},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }